
import React, { useState, useEffect } from 'react';
import { ChevronLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { InsightCard } from '@/types/insight';
import { Badge } from '../ui/badge';

interface InsightPageHeaderProps {
  card: InsightCard;
}

const InsightPageHeader: React.FC<InsightPageHeaderProps> = ({ card }) => {
  const [formattedDate, setFormattedDate] = useState<string>('');

  useEffect(() => {
    if (card.updated_at) {
      const date = new Date(card.updated_at);
      setFormattedDate(date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      }));
    }
  }, [card.updated_at]);

  return (
    <div className="mb-8">
      <div className="flex items-center gap-2 mb-4">
        <Link to="/insights" className="flex items-center text-muted-foreground hover:text-foreground transition-colors">
          <ChevronLeft className="h-4 w-4 mr-1" />
          Back to Insights
        </Link>
      </div>

      <div className="flex flex-wrap items-start justify-between gap-4">
        <div>
          <div className="flex items-center gap-2 mb-2">
            <Badge variant="outline" className="bg-primary/10 text-primary border-primary/20">
              {card.category}
            </Badge>
            {card.country_code && (
              <Badge variant="secondary" className="bg-secondary/10 text-secondary border-secondary/20">
                {card.country_code}
              </Badge>
            )}
          </div>
        </div>
        <div className="text-sm text-muted-foreground">
          Updated: {formattedDate}
        </div>
      </div>
    </div>
  );
};

export default InsightPageHeader;
